@let viewportSize = viewportState().viewportSize;

@let label = storeLabel();
@let phone = storePhoneNumber();

@if(viewportSize === 'large') {
    @if(label || phone) {
        <div class="store-info-desktop">
            @if(label) {
                <button
                    class="button-undecorated store-info-button"
                    [attr.aria-label]="'Store Address, ' + label"
                    (click)="onStoreInfoClick()"
                >
                    <span class="btn-label"> {{ label }} </span>
                    <cwo-icon [name]="iconName.arrow" class="icon" aria-hidden="true" />
                </button>
            }
            @if(phone) {
                <a [href]="'tel:' + phone" class="store-info-button store-phone" [attr.aria-label]="'Store Phone, ' + phone">
                    {{ phone }}
                </a>
            }
        </div>
    }
}